import { z } from 'zod';
export const GetOrganizationConnectionsRequestPathSchema = z.object({
    organizationId: z.string(),
});
export const GetOrganizationConnectionsRequestSchema = GetOrganizationConnectionsRequestPathSchema;
export const GetOrganizationConnectionsResponseSchema = z.object({
    connections: z.string().array(),
});
export const GetOrganizationConnectionsApiSchema = {
    params: GetOrganizationConnectionsRequestPathSchema,
    response: GetOrganizationConnectionsResponseSchema,
};
